import React, { useContext } from 'react'
import { ThemeContext, H1, Text, View, Center } from '~/pagui'
import { css } from '@emotion/native'
import { LG_SIZE } from '~/pagui/components/View'
import Parallax from '~/components/Parallax'

type Props = {
  title: string
  subtitle?: string
}

const viewStyle = css({
  backgroundColor: '#141414',
  height: 650,
  overflow: 'hidden',
})

const headerStyle = css({
  color: 'white',
  textAlign: 'center',
  zIndex: 100,
})

const headerTitle = css({
  fontSize: 55,
  lineHeight: 60,
})

const subStyle = css({
  fontSize: 25,
  fontFamily: 'Matrice-Regular',
})

// // RESPONSIVE ---------------------------------------------------------------------------------------
const headerTitleLG = css({
  fontSize: 25,
  lineHeight: 30,
  zIndex : 10

})

const viewStyleLG = css({
  backgroundColor: '#141414',
  height: 450,
})

const subStyleLG = css({
  fontSize: 15,
  fontFamily: 'Matrice-Regular',
})

const Header: React.FC<Props> = ({ title, subtitle }) => {
  const [theme] = useContext(ThemeContext)

  return (
    <>
      <View
        minShowSize={LG_SIZE}
        style={[viewStyle, theme.styles.p4, theme.styles.flexColCenter]}
      >
        <Parallax />
        <H1
          style={[headerStyle, theme.styles.mt5, theme.styles.mb3, headerTitle]}
        >
          {title}
        </H1>
        <Text
          style={[headerStyle, subStyle, theme.styles.pb4, theme.styles.pt4]}
        >
          {subtitle}
        </Text>
      </View>
      <View
        maxShowSize={LG_SIZE}
        style={[viewStyleLG, theme.styles.p2, theme.styles.flexColCenter]}
      >
        <Parallax isResp />
        <Center>
          <>
            <H1 style={[headerStyle, theme.styles.mb2, headerTitleLG]}>
              {title}
            </H1>
            <Text
              style={[
                headerStyle,
                subStyleLG,
                theme.styles.pb4,
                theme.styles.pt2,
              ]}
            >
              {subtitle}
            </Text>
          </>
        </Center>
      </View>
    </>
  )
}

export default Header
